import { GetCatchRanking, SendCatchAdminControl, EditCatchPlayer, SendCatchScreenCommand, GetAllCatchPlayers, ResetAllCatchScores, SubmitManualCatchScore, GiveSecondChance } from './../DL/CatchTheBall'


let catchSocket = null;
let isCatchConnected = false;

// ==========================================================================
// 🔌 WEBSOCKET (Solo para escuchar cuándo la pantalla gigante termina el juego)
// ==========================================================================
const ConnectCatchTheBallWebSocket = async (onStatus = () => {}, onMessage = () => {}) => {
    if (catchSocket || isCatchConnected) return;

    // Nos conectamos como gamepad
    catchSocket = new WebSocket(`${process.env.REACT_APP_API_URL_WSS}?tipo=catchtheball:gamepad`);
    onStatus('connecting');

    catchSocket.onopen = () => {
        isCatchConnected = true;
        onStatus('connected');
    };

    catchSocket.onmessage = (evt) => {
        try { 
            const msg = JSON.parse(evt.data);
            if (msg?.type?.toLowerCase() === 'catchtheball') {
                onMessage(msg.data); // Pasamos el action y payload
            }
        } catch (error) {}
    };

    catchSocket.onclose = () => {
        isCatchConnected = false;
        catchSocket = null;
        onStatus('disconnected');
    };
};

const DisconnectCatchTheBallWebSocket = () => {
    if (catchSocket) {
        catchSocket.onclose = null;
        catchSocket.onmessage = null;
        catchSocket.close();
        catchSocket = null;
        isCatchConnected = false;
    }
};

// ==========================================================================
// 📡 REST API (Peticiones del Gamepad)
// ==========================================================================
const JoinCatchTheBallGame = async (userData) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}CatchTheBall/Join`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(userData)
        });
        return { success: response.ok };
    } catch (error) {
        return { success: false };
    }
};

// Función ultrarrápida (fire-and-forget) para no trabar el celular
const SendGamepadCommand = (commandStr) => {
    fetch(`${process.env.REACT_APP_API_URL}CatchTheBall/Gamepad`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ command: commandStr })
    }).catch(() => {}); // Ignoramos errores de red para no frenar la experiencia
};


//--- Admin ---//

const GetRankingBL = async () => await GetCatchRanking();
const EditPlayerBL = async (id, nickname, isCensored) => await EditCatchPlayer(id, nickname, isCensored);
const SendScreenCommandBL = async (commandStr, payload = null) => await SendCatchScreenCommand(commandStr, payload);
const AdminControlBL = async (actionStr, durationValue = null) => await SendCatchAdminControl(actionStr, durationValue);

const GetAllPlayersBL = async () => await GetAllCatchPlayers();
const ResetAllScoresBL = async () => await ResetAllCatchScores();
const SubmitManualScoreBL = async (userData) => await SubmitManualCatchScore(userData);
const GiveSecondChanceBL = async (userData) => await GiveSecondChance(userData);

//--- Admin ---//

export { ConnectCatchTheBallWebSocket, DisconnectCatchTheBallWebSocket, JoinCatchTheBallGame, SendGamepadCommand, GetRankingBL, EditPlayerBL, SendScreenCommandBL, AdminControlBL, GetAllPlayersBL, ResetAllScoresBL, SubmitManualScoreBL, GiveSecondChanceBL };